import { render, staticRenderFns } from "./NewTag.vue?vue&type=template&id=46bb29c9&scoped=true"
import script from "./NewTag.vue?vue&type=script&lang=js"
export * from "./NewTag.vue?vue&type=script&lang=js"
import style0 from "./NewTag.vue?vue&type=style&index=0&id=46bb29c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bb29c9",
  null
  
)

export default component.exports